<div class="settings-tab">
  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <pdq-heading element="h6">Token for Shopify</pdq-heading>
      <pdq-divider></pdq-divider>
      <pdq-input
        [disabled]="true"
        [formControl]="formGroup.controls.usageToken"
        label="Copy & paste this into Shopify's components by 'Multi shipment'"
        [clipboard]="true"></pdq-input>
      <pdq-extension-preview-token [usageTokenControl]="formGroup.controls.usageToken"></pdq-extension-preview-token>
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <pdq-heading element="h6">General</pdq-heading>
      <pdq-divider></pdq-divider>
      <pdq-input
        label="Internal name"
        [formControl]="formGroup.controls.internalName"
        [invalid]="
          (formGroup.controls.internalName.dirty || formGroup.controls.internalName.touched) &&
          formGroup.controls.internalName.invalid
        "
        invalidMsg="Internal name is required"></pdq-input>
      <pdq-input
        label="Internal description"
        [formControl]="formGroup.controls.internalDescription"
        placeholder="Enter description (optional)"></pdq-input>
    </div>
  </pdq-card>
</div>
